import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import gridTexture from "@/assets/grid-texture.jpg";

export const CTA = () => (
  <section className="relative py-32 border-t border-border overflow-hidden">
    <img src={gridTexture} alt="" loading="lazy" width={1536} height={1024}
      className="absolute inset-0 w-full h-full object-cover opacity-50" />
    <div className="absolute inset-0 bg-radial-fire" />
    <div className="container relative text-center max-w-3xl">
      <h2 className="font-serif-display text-5xl md:text-7xl font-light leading-[1.05] mb-8">
        El fuego ya no <br/>
        <span className="text-ember italic">pertenece a los dioses.</span>
      </h2>
      <p className="text-muted-foreground text-lg mb-10 max-w-xl mx-auto leading-relaxed">
        Únete al primer laboratorio donde el conocimiento se hereda, se construye con las manos y se devuelve al mundo.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4">
        <Link to="/dashboard">
          <Button variant="ember" size="xl">
            Entrar al Dashboard <ArrowRight />
          </Button>
        </Link>
        <Link to="/mentes">
          <Button variant="spark" size="xl">Conoce a las Mentes</Button>
        </Link>
      </div>
    </div>
  </section>
);